import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38ba7bd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-ctc" }
const _hoisted_2 = { class: "nge-ctc-lead" }
const _hoisted_3 = { class: "nge-ctc-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "nge-ctc-busy"
}
const _hoisted_6 = {
  key: 0,
  class: "nge-ctc-problem"
}
const _hoisted_7 = { class: "nge-ctc-counts" }
const _hoisted_8 = { class: "nge-ctc-note" }
const _hoisted_9 = {
  key: 0,
  class: "nge-ctc-send"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Only saves CAVE never took, each at its own logged point. CAVE will record you as the one who saved them.", -1 /* HOISTED */))
const _hoisted_12 = {
  key: 1,
  class: "nge-ctc-list-head"
}
const _hoisted_13 = {
  key: 2,
  class: "nge-ctc-allgood"
}
const _hoisted_14 = {
  key: 3,
  class: "nge-ctc-table"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Saved"),
    /*#__PURE__*/_createElementVNode("th", null, "Player"),
    /*#__PURE__*/_createElementVNode("th", null, "Cell"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Point")
  ])
], -1 /* HOISTED */))
const _hoisted_16 = { class: "nge-ctc-id" }
const _hoisted_17 = { class: "nge-ctc-id" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" Compares every cell type in the game's log with CAVE's table for "),
      _createElementVNode("b", null, _toDisplayString($setup.datasetDisplayName($setup.dataset) || $setup.dataset), 1 /* TEXT */),
      _createTextVNode(", the dataset on screen. Nothing is changed by checking. ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "nge-admin-primary-btn",
        disabled: !!$setup.busy || $setup.sending,
        onClick: $setup.run
      }, _toDisplayString($setup.busy ? 'Checking…' : $setup.result ? 'Check again' : 'Check cell types against CAVE'), 9 /* TEXT, PROPS */, _hoisted_4),
      ($setup.busy)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.busy), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.problem)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.problem), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.result)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ORDER, (s) => {
              return _createElementVNode("div", {
                key: s,
                class: _normalizeClass(["nge-ctc-count", `nge-ctc-count--${s}`])
              }, [
                _createElementVNode("b", null, _toDisplayString($setup.result.counts[s]), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.LABEL[s]), 1 /* TEXT */)
              ], 2 /* CLASS */)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(" One row per cell: its newest logged type. "),
            ($setup.result.caveUpTo)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("CAVE's list goes up to " + _toDisplayString($setup.when($setup.result.caveUpTo)) + ". A save after that which CAVE did accept shows as too new until CAVE lists it.", 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("CAVE listed no rows, so nothing logged can be confirmed yet.")
                ], 64 /* STABLE_FRAGMENT */))
          ]),
          ($setup.result.counts.resend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "nge-admin-primary-btn",
                  disabled: $setup.sending || !$setup.toSend.length,
                  onClick: $setup.sendAgain
                }, _toDisplayString($setup.sending ? 'Sending…' : $setup.toSend.length ? `Send ${$setup.toSend.length} to CAVE again` : 'All sent'), 9 /* TEXT, PROPS */, _hoisted_10),
                _hoisted_11
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.shown.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString($setup.shown.length) + " not confirmed in CAVE", 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "nge-admin-action-btn",
                  onClick: $setup.copyList
                }, "Copy the list")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, "Every logged cell type is in CAVE.")),
          ($setup.shown.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shown, (r) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: r.segId,
                      class: _normalizeClass(`nge-ctc-row--${r.status}`)
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString($setup.LABEL[r.status]), 1 /* TEXT */),
                        (r.caveType)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(": " + _toDisplayString(r.caveType), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        ($setup.sent[r.segId])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["nge-ctc-sent", { 'nge-ctc-sent--bad': $setup.sent[r.segId] !== 'sent' }])
                            }, _toDisplayString($setup.sent[r.segId] === 'sent' ? '✓ Sent to CAVE' : $setup.sent[r.segId]), 3 /* TEXT, CLASS */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString($setup.when(r.at)), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString($setup.names[r.userId] || '…'), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(r.segId), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(r.type), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(r.point ? r.point.join(', ') : ''), 1 /* TEXT */)
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}